import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumUkNewDutyRate implements BaseEnumType {
  private static allValues: EnumUkNewDutyRate[] = []; // make sure this is top-most
  
  public static none = new EnumUkNewDutyRate(0, "None", "enum_uk_new_duty_rate_none");
  public static nonSpiritsAbvTo3_4NotDraught = new EnumUkNewDutyRate(1, "NonSpiritsAbvTo3_4NotDraught", "enum_uk_new_duty_rate_non_spirits_abv_to3_4_not_draught");
  public static nonSpiritsAbvTo3_4Draught = new EnumUkNewDutyRate(2, "NonSpiritsAbvTo3_4Draught", "enum_uk_new_duty_rate_non_spirits_abv_to3_4_draught");
  public static spiritsAbvTo3_4NotDraught = new EnumUkNewDutyRate(3, "SpiritsAbvTo3_4NotDraught", "enum_uk_new_duty_rate_spirits_abv_to3_4_not_draught");
  public static spiritsAbvTo3_4Draught = new EnumUkNewDutyRate(4, "SpiritsAbvTo3_4Draught", "enum_uk_new_duty_rate_spirits_abv_to3_4_draught");
  public static mediumCiderNotDraught = new EnumUkNewDutyRate(5, "MediumCiderNotDraught", "enum_uk_new_duty_rate_medium_cider_not_draught");
  public static mediumCiderDraught = new EnumUkNewDutyRate(6, "MediumCiderDraught", "enum_uk_new_duty_rate_medium_cider_draught");
  public static mediumBeerNotDraught = new EnumUkNewDutyRate(7, "MediumBeerNotDraught", "enum_uk_new_duty_rate_medium_beer_not_draught");
  public static mediumBeerDraught = new EnumUkNewDutyRate(8, "MediumBeerDraught", "enum_uk_new_duty_rate_medium_beer_draught");
  public static mediumWineNotDraught = new EnumUkNewDutyRate(9, "MediumWineNotDraught", "enum_uk_new_duty_rate_medium_wine_not_draught");
  public static mediumWineDraught = new EnumUkNewDutyRate(10, "MediumWineDraught", "enum_uk_new_duty_rate_medium_wine_draught");
  public static mediumSpiritsNotDraught = new EnumUkNewDutyRate(11, "MediumSpiritsNotDraught", "enum_uk_new_duty_rate_medium_spirits_not_draught");
  public static mediumSpiritsDraught = new EnumUkNewDutyRate(12, "MediumSpiritsDraught", "enum_uk_new_duty_rate_medium_spirits_draught");
  public static abv8_5To22_0 = new EnumUkNewDutyRate(13, "Abv8_5To22_0", "enum_uk_new_duty_rate_abv8_5_to22_0");
  public static abvFrom22_1 = new EnumUkNewDutyRate(14, "AbvFrom22_1", "enum_uk_new_duty_rate_abv_from22_1");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumUkNewDutyRate.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumUkNewDutyRate.none; }
  public isNonSpiritsAbvTo3_4NotDraught() { return this === EnumUkNewDutyRate.nonSpiritsAbvTo3_4NotDraught; }
  public isNonSpiritsAbvTo3_4Draught() { return this === EnumUkNewDutyRate.nonSpiritsAbvTo3_4Draught; }
  public isSpiritsAbvTo3_4NotDraught() { return this === EnumUkNewDutyRate.spiritsAbvTo3_4NotDraught; }
  public isSpiritsAbvTo3_4Draught() { return this === EnumUkNewDutyRate.spiritsAbvTo3_4Draught; }
  public isMediumCiderNotDraught() { return this === EnumUkNewDutyRate.mediumCiderNotDraught; }
  public isMediumCiderDraught() { return this === EnumUkNewDutyRate.mediumCiderDraught; }
  public isMediumBeerNotDraught() { return this === EnumUkNewDutyRate.mediumBeerNotDraught; }
  public isMediumBeerDraught() { return this === EnumUkNewDutyRate.mediumBeerDraught; }
  public isMediumWineNotDraught() { return this === EnumUkNewDutyRate.mediumWineNotDraught; }
  public isMediumWineDraught() { return this === EnumUkNewDutyRate.mediumWineDraught; }
  public isMediumSpiritsNotDraught() { return this === EnumUkNewDutyRate.mediumSpiritsNotDraught; }
  public isMediumSpiritsDraught() { return this === EnumUkNewDutyRate.mediumSpiritsDraught; }
  public isAbv8_5To22_0() { return this === EnumUkNewDutyRate.abv8_5To22_0; }
  public isAbvFrom22_1() { return this === EnumUkNewDutyRate.abvFrom22_1; }

  public static getValues(): readonly EnumUkNewDutyRate[] {
    return EnumUkNewDutyRate.allValues;
  }

  public static getValuesExcept0(): readonly EnumUkNewDutyRate[] {
    return EnumUkNewDutyRate.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumUkNewDutyRate {
    const found = EnumUkNewDutyRate.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUkNewDutyRate - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumUkNewDutyRate): EnumUkNewDutyRate {
    const found = name ? EnumUkNewDutyRate.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumUkNewDutyRate - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumUkNewDutyRate>): boolean {
    return this.key === other?.key;
  }
}